import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";

const DemographicInfoColumn = ({ candidate, isCollapsible, isUser }) => {
  const { t } = useTranslation();

  return (
    <Row className="mx-0 justify-content-evenly" style={{ minWidth: !isCollapsible ? "600px" : "0px" }}>
      <Col xs={isCollapsible ? 12 : 6} md={isCollapsible && 6} className="fw-medium">
        {isUser && (
          <Row>
            <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
              {t("nameLabel")}:
            </Col>
            <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
              {candidate?.name}
            </Col>
          </Row>
        )}

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("phoneLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {candidate?.phoneNumber}
          </Col>
        </Row>

        {!isUser && (
          <Row>
            <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
              {t("positionLabel")}:
            </Col>
            <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
              {candidate?.positionName}
            </Col>
          </Row>
        )}

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("genderLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.gender)}
          </Col>
        </Row>

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("educationLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.school)}
          </Col>
        </Row>
      </Col>

      <Col xs={isCollapsible ? 12 : 6} md={isCollapsible && 6} className="fw-medium">
        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("birthYearLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.birthYear)}
          </Col>
        </Row>

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("experienceLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.experience)}
          </Col>
        </Row>

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("facultyLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.faculty)}
          </Col>
        </Row>

        <Row>
          <Col xs="auto" className="px-0 align-content-center text-16 text-color-gray-light">
            {t("departmentLabel")}:
          </Col>
          <Col xs="auto" className="px-1 align-content-center text-18 text-color-gray-dark">
            {t(candidate?.department)}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DemographicInfoColumn;
